<script type="text/ecmascript-6">
    import Layout from '../layouts/Index.vue'
    import MainHeader from '../layouts/Header.vue'

    export default {
        name: 'SupportGuide',

        components: {
            Layout,
            MainHeader,
        },

        metaInfo() {
            return {
                title: 'Support Guide',
            }
        },

        /**
         * The component's data.
         */
        data: () => ({
            description: '',
        }),


        /**
         * Created the component.
         */
        created() {
            this.fetchSupportGuide();
        },

        methods: {
            /**
             *  Get albums.
             */
            async fetchSupportGuide() {
                axios.get('/api/mmn/support-guide').then((response) => {
                    this.description = response.data;
                }).catch((error) => {

                });
            },
        }
    }
</script>

<template>
    <layout>

        <!---Main Content Start--->
        <div class="ms_content_wrapper ms_profile padder_top80">

            <main-header/>

            <div class="ms_radio_wrapper ms_purchase_wrapper">
                <div class="ms_heading">
                    <h1>Support Guide</h1>
                </div>
                <div class="row">
                    <div class="container" v-html="description"></div>
                </div>
            </div>
        </div>


    </layout>
</template>
